console.log("helpers loaded");

function isObject(item) {
  return typeof item === "object" && !Array.isArray(item) && item !== null;
}
// Function to gat a random  array item
function getRandomItem(array) {
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
}
// Function to generate a random index within the array length
function getRandomIndex(arrayLength) {
  return Math.floor(Math.random() * arrayLength);
}

/* function sumDigitsUntil12(number) {
  return number <= 12
    ? number
    : sumDigitsUntil12(
        [...String(number)].reduce((acc, digit) => acc + parseInt(digit), 0)
      );
} */

// Function to join digits and then sum them until the result is <= 12
function joinAndSumDigits(...digits) {
  // for every digit add up until one digit remains
  //console.log("digits", digits);

  for (let i = 0; i < digits.length; i++) {
    //remove trailing zeros
    digits[i] = parseInt(digits[i]);
    if (digits[i] > 9) {
      digits[i] = sumDigitsUntil12(digits[i]);
    }
  }

  //console.log("digits adjusted", digits);

  // Join the digits together to form a single number
  const number = parseInt(digits.join(""));
  // Pass the number to the sumDigitsUntil12 function
  //console.log("number joined", number);
  let result = sumDigitsUntil12(number);
  //console.log("result", result);
  return result;
}

function sumDigitsUntil12(number) {
  while (number > 12) {
    number = [...String(number)].reduce(
      (acc, digit) => acc + parseInt(digit),
      0
    );
  }
  return number;
}

const defaultNumbers = () => {
  return {
    heart: 0,
    west: 0, // wissel oost en west bij relatiewiel
    south: 0,
    east: 0, // wissel oost en west bij relatiewiel
    north: 0,
  };
};

// calculate the wheel numbers based on date format string dd-mm-yyyy
function calculateWheelNumbers(date) {
  // date format = dd-mm-yyyy

  //TODO error checking and returning default
  try {
    if (date && date.length > 9) {
      //console.log("date control", date);
      const [day, month, year] = date.split("-");
      return {
        air: sumDigitsUntil12(parseInt(year + month + day)),
        fire: sumDigitsUntil12(parseInt(year.slice(2))),
        water: sumDigitsUntil12(parseInt(month)),
        earth: sumDigitsUntil12(parseInt(year)),
        heart: sumDigitsUntil12(parseInt(day)),
      };
    }
  } catch (err) {
    console.log(err);
    return { heart: null, air: null, fire: null, water: null, earth: null };
  }
}

function calculateGroupWheelNumbers(dates) {
  //console.log(dates);
  let sumHeart = 0;
  let sumAir = 0;
  let sumFire = 0;
  let sumWater = 0;
  let sumEarth = 0;
  if (dates) {
    dates.forEach((date) => {
      // Split the date into day, month, and year
      const [day, month, year] = date.split("-");

      // Sum the digits of each component and accumulate the total sum
      sumHeart += sumDigitsUntil12(parseInt(day));
      console.log("sumHeart", sumHeart);
      sumAir += sumDigitsUntil12(parseInt(year + month + day));
      sumFire += sumDigitsUntil12(parseInt(year.slice(2)));
      sumWater += sumDigitsUntil12(parseInt(month));
      sumEarth += sumDigitsUntil12(parseInt(year));
    });
  }

  return {
    heart: sumHeart,
    air: sumAir,
    fire: sumFire, // wissel oost en west bij relatiewiel
    water: sumWater,
    earth: sumEarth, // wissel oost en west bij relatiewiel
  };
}

function calculateFriendWheelNumbers(dates) {
  let sumHeart = 0;
  let sumAir = 0;
  let sumFire = 0;
  let sumWater = 0;
  let sumEarth = 0;

  if (dates) {
    //console.log("dates", dates);
    // Split the date into day, month, and year
    const [day0, month0, year0] = dates[0].split("-");
    const [day1, month1, year1] = dates[1].split("-");

    // Sum the digits of each component and accumulate the total sum
    sumHeart = sumDigitsUntil12(
      sumDigitsUntil12(parseInt(day0)) + sumDigitsUntil12(parseInt(day1))
    );
    sumAir = sumDigitsUntil12(
      sumDigitsUntil12(parseInt(year0 + month0 + day0)) +
        sumDigitsUntil12(parseInt(year1 + month1 + day1))
    );
    sumFire = sumDigitsUntil12(
      sumDigitsUntil12(parseInt(year0.slice(2))) +
        sumDigitsUntil12(parseInt(year1.slice(2)))
    );
    sumWater = sumDigitsUntil12(
      sumDigitsUntil12(parseInt(month0)) + sumDigitsUntil12(parseInt(month1))
    );
    sumEarth = sumDigitsUntil12(
      sumDigitsUntil12(parseInt(year0)) + sumDigitsUntil12(parseInt(year1))
    );
  }
  return {
    heart: sumHeart,
    air: sumAir,
    fire: sumFire,
    water: sumWater,
    earth: sumEarth,
  };
}

function calculateLoveWheelNumbers(dates) {
  //console.log("dates", dates);
  let sumHeart = 0;
  let sumAir = 0;
  let sumFire = 0;
  let sumWater = 0;
  let sumEarth = 0;
  if (dates) {
    // Split the date into day, month, and year
    const [day0, month0, year0] = dates[0].split("-");
    const [day1, month1, year1] = dates[1].split("-");

    // Sum the digits of each component and accumulate the total sum
    sumHeart = joinAndSumDigits(day0, day1);
    sumAir = joinAndSumDigits(
      joinAndSumDigits(year0, month0, day0),
      joinAndSumDigits(year1, month1, day1)
    );
    sumFire = joinAndSumDigits(
      joinAndSumDigits(year0.slice(2)),
      joinAndSumDigits(year1)
    );
    sumWater = joinAndSumDigits(month0, month1);
    sumEarth = joinAndSumDigits(
      joinAndSumDigits(year0),
      joinAndSumDigits(year1.slice(2))
    );
  }

  return {
    heart: sumHeart,
    air: sumAir,
    fire: sumFire,
    water: sumWater,
    earth: sumEarth,
  };
}
// get shade of hex color
function adjustColor(color, amount) {
  return (
    "#" +
    color
      .replace(/^#/, "")
      .replace(/../g, (color) =>
        (
          "0" +
          Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
        ).substr(-2)
      )
  );
}

function sendEmail(to, subject, body) {
  var link =
    "mailto:" +
    to +
    "?subject=" +
    encodeURIComponent(subject) +
    "&body=" +
    encodeURIComponent(body);

  window.open(link, "_blank");
}

function toLiveReading() {
  window
    .open("https://tidycal.com/verdieping7/soul-profiler-reading", "_blank")
    .focus();
}
function toIntroReading() {
  window
    .open(
      "https://tidycal.com/verdieping7/soul-profiler-reading-kennismaking",
      "_blank"
    )
    .focus();
}

export {
  adjustColor,
  isObject,
  getRandomItem,
  getRandomIndex,
  sumDigitsUntil12,
  joinAndSumDigits,
  defaultNumbers,
  calculateWheelNumbers,
  calculateFriendWheelNumbers,
  calculateLoveWheelNumbers,
  calculateGroupWheelNumbers,
  sendEmail,
  toLiveReading,
  toIntroReading,
};
